import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {
  loadBrandingConfiguration() {
    return this.http.get('/api/appconfiguration/branding');
  }

  constructor(private http: HttpClient) { }

  loadAppConfiguration() {
    return this.http.get('/api/appconfiguration');
  }
}
